// THIS FILE IS AUTO-GENERATED BY scripts/generate-bending-index.cjs
// DO NOT EDIT DIRECTLY.

export interface CalculatedMetric {
  strength: number | null;
  modulus: number | null;
}

export const calculatedMetrics: Record<string, { default: CalculatedMetric; zAxis: CalculatedMetric }> = {
  "pla-cf": {
    "default": {
      "strength": 63.13,
      "modulus": 3022
    },
    "zAxis": {
      "strength": null,
      "modulus": null
    }
  },
  "pla-pro": {
    "default": {
      "strength": 72.92,
      "modulus": 2593
    },
    "zAxis": {
      "strength": 37.57,
      "modulus": 2192
    }
  },
  "pla-silk": {
    "default": {
      "strength": 45.94,
      "modulus": 1750
    },
    "zAxis": {
      "strength": 15.1,
      "modulus": 1484
    }
  },
  "pla": {
    "default": {
      "strength": 77.05,
      "modulus": 2879
    },
    "zAxis": {
      "strength": null,
      "modulus": null
    }
  },
  "petg": {
    "default": {
      "strength": 76.69,
      "modulus": 2033
    },
    "zAxis": {
      "strength": 26.59,
      "modulus": 1703
    }
  },
  "pla-plus": {
    "default": {
      "strength": 78.59,
      "modulus": 2890
    },
    "zAxis": {
      "strength": null,
      "modulus": null
    }
  }
};
